import BaseBehavior from '../../../framework/base/base';

export default class ImageAccordion extends BaseBehavior{
    image: HTMLImageElement;
    constructor(element: HTMLElement) {
        super(element);
        this.image = this.element.querySelector('img');
		this.addEventListeners();
    }

    addEventListeners(): void {
        this.addEventListener(this.element, 'click', (e: Event) => {
            const target  = e.target as HTMLElement;
			const label = target.nodeName === 'LABEL' ? target : target.closest('label');           
			if (label?.getAttribute('data-accordion-img-src')) {
				const src: string|null = label.getAttribute('data-accordion-img-src');
                this.image.src = src ?? '';
			}
		});
    }

    removeEventListeners(): void {
		this.removeEventListener(this.element, 'click');
	}
}